<template>
    <v-container>
        <v-row class="mt-3" align="center">
            <v-col cols="12">
                <div class="headline-light secondary-color">
                    Perfil {{ currentEntityLabel }}
                </div>
                <div class="display-heavy primary-color">
                    Perfiles Médicos
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <kimsa-combobox
                    label="Mostrar"
                    @change="profile = $event"
                    :value="profile"
                    :items="profiles"
                    outlined dense
                    force-value
                    style="max-width: 250px"
                />
            </v-col>
            <v-col cols="12" md="6" align="right">
                <v-btn class="normal-btn" color="primary" outlined large @click="addProfile">
                    Agregar Perfil
                </v-btn>
            </v-col>
            <v-col cols="12" v-if="profileId || isAdding">
                <profile-details ref="details" :profile-id="profileId" @save="onSaveProfile"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import ProfileDetails from "@/views/admin/profiles/ProfileDetails";
import httpService from "@/services/httpService";

export default {
    name: "Profiles",
    components: {ProfileDetails, KimsaCombobox},
    data() {
        return {
            loadingProfiles: false,
            profiles: [],
            profile: null,
            isAdding: false,
        }
    },
    computed: {
        profileId(vm = this) {
            return vm.profile?.id || null
        }
    },
    async mounted() {
        const vm = this
        if(vm.currentEntityId) await vm.loadProfiles()
    },
    methods: {
        async loadProfiles() {
            const vm = this
            vm.loadingProfiles = true

            let response = await httpService.get(`laboratory/${vm.currentEntityId}/profiles`)
            // console.log('response loadProfiles',response)
            vm.profiles = response.data.profiles

            vm.loadingProfiles = false
        },
        addProfile() {
            const vm = this
            vm.profile = null
            if(vm.$refs.details) vm.$refs.details.reset()
            vm.isAdding = true
        },
        onSaveProfile() {
            const vm = this
            vm.addProfile()
            vm.isAdding = false
            vm.loadProfiles()
        },
    },
    watch: {
        currentEntityId(val) {
            if (val) this.loadProfiles()
        }
    }
}
</script>

<style scoped>

</style>